'use client'

import React, { useEffect, useState } from 'react'

/**
 * Preloader em grade (overlay na cor primária cujas células somem em cascata).
 * Aparece uma vez por sessão; some em ~1 s. Sem JS, não bloqueia nada (só existe no cliente).
 */
export function Preloader({ colunas = 8, linhas = 5 }: { colunas?: number; linhas?: number }) {
  const [estado, setEstado] = useState<'oculto' | 'ativo' | 'saindo'>('oculto')

  useEffect(() => {
    try {
      if (sessionStorage.getItem('ag-preloader') === '1') return
      sessionStorage.setItem('ag-preloader', '1')
    } catch {
      /* sem storage: mostra na mesma */
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    setEstado('ativo')
    const t1 = setTimeout(() => setEstado('saindo'), 350)
    const t2 = setTimeout(() => setEstado('oculto'), 1500)
    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [])

  if (estado === 'oculto') return null
  const total = colunas * linhas
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[9999] grid"
      style={{ gridTemplateColumns: `repeat(${colunas}, 1fr)`, gridTemplateRows: `repeat(${linhas}, 1fr)` }}
    >
      {Array.from({ length: total }, (_, i) => {
        const col = i % colunas
        const row = Math.floor(i / colunas)
        return (
          <div
            key={i}
            className={estado === 'saindo' ? 'ag-preloader-cell' : undefined}
            style={{
              background: 'var(--ag-primary)',
              animationDelay: `${(col + row) * 45}ms`,
              transformOrigin: 'center',
            }}
          />
        )
      })}
    </div>
  )
}
